angular.module('bmsApp.global.direction')
	.factory('DirectionSvc', [
		'$ngBootbox',
		'$window',
		function ($ngBootbox,
				  $window) {

			function printDirections(params) {
				var actionCallback = function (extraParams) {
					var paramString = $.param(angular.extend({}, params, extraParams));
					$window.open('directions?' + paramString, '_blank');
				};
				var options = {
					message: 'Would you like to view all directional information?',
					title: 'Print Directions',
					buttons: {
						directions: {
							label: "Just Directions",
							className: "btn-info",
							callback: function () {
								actionCallback({
									view: 'directions'
								});
							}
						},
						map: {
							label: "Just Maps",
							className: "btn-info",
							callback: function () {
								actionCallback({
									view: 'map'
								});
							}
						},
						all: {
							label: "All",
							className: "btn-success",
							callback: function () {
								actionCallback({
									view: 'all'
								});
							}
						}
					}
				};
				$ngBootbox.customDialog(options);
			}

			return {
				printDirections: printDirections
			};

		}
	]);
